<template>
  <div
    class="flex items-center justify-between p-4 bg-white dark:border-gray-800 shadow-md rounded-lg"
  >
    <div>
      <p class="font-medium text-gray-800">{{ title }}</p>
      <p class="text-sm text-gray-500">{{ currentPage }} / {{ totalPages }}</p>
    </div>

    <div class="flex items-center gap-4">
      <Button
        icon="pi pi-arrow-left"
        @click="prevPage"
        :disabled="currentPage === 1"
      />

      <Button
        icon="pi pi-arrow-right"
        @click="nextPage"
        :disabled="currentPage === totalPages"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { defineEmits, defineProps, ref, watch } from 'vue';

  // Пропсы
  const props = defineProps<{
    title: string;
    totalPages: number;
    activePage: number;
  }>();

  const emit = defineEmits<{
    (event: 'update:currentPage', value: number): void;
  }>();

  const currentPage = ref(props.activePage);

  const nextPage = () => {
    if (currentPage.value < props.totalPages) {
      currentPage.value++;
    }
  };

  const prevPage = () => {
    if (currentPage.value > 1) {
      currentPage.value--;
    }
  };

  watch(currentPage, (newValue) => {
    emit('update:currentPage', newValue);
  });
</script>
